import { render, staticRenderFns } from "./LocalizationSelector.vue?vue&type=template&id=742b8e4f&scoped=true&"
import script from "./LocalizationSelector.vue?vue&type=script&lang=js&"
export * from "./LocalizationSelector.vue?vue&type=script&lang=js&"
import style0 from "./LocalizationSelector.vue?vue&type=style&index=0&id=742b8e4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742b8e4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
